export const cssMediaQueryLargeScreen = "@media (min-width: 1200px)";
export const cssMediaQueryMinWidthDesktop = "@media (min-width: 1024px)";
export const cssMediaQueryMinWidthTablet = "@media (min-width: 768px)";
export const cssMediaQueryMaxWidthTinyMobile = "@media (max-width: 600px)";
export const cssMediaQueryMinHeightNormal =
  "@media screen and (min-height: 850px)";
export const cssMediaQueryMinHeightSmall =
  "@media screen and (min-height: 600px) and (max-height: 850px)";

export const cssMediaQueryPrefersReducedMotion =
  "@media (prefers-reduced-motion: reduce)";

export const cssMediaQueryPrefersMoreContrast =
  "@media (prefers-contrast: more)";

export const cssMediaQueryIsSafari = "@supports (hanging-punctuation: first)";
